import { apiUrl, authHeaders } from './auth';

export const fetchCampaignContext = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/getStarted/campaign';
  const resp = await fetch(url, {
    // method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const campaignWho = async (payload) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/who';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const campaignPatientDetails = async (payload) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/patient/details';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  if (resp.status == 500) {
    return { error: 'An Error has Occured, email may already be in use' };
  }

  const json = await resp.json();
  return json;
};

export const campaignType = async (typeId) => {
  const payload = {
    typeId,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/condition/type';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setInjuryTimeFrame = async (
  injuryTimeFrameCode: string,
  injuryDate: string | null
) => {
  console.log('injuryTimeFrameCode: ', injuryTimeFrameCode);
  const payload = {
    injuryTimeFrameCode,
    injuryDate,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/condition/timeframe';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const searchMedicalCenters = async (state: string) => {
  const payload = {
    state,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/searchMedicalCenters';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const searchMedicalProfessionals = async (medCenterId) => {
  const payload = {
    medCenterId,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/searchMedicalProfessionals';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setMedicalProfessional = async (
  medCenterId,
  personId,
  consent: boolean,
  certifyIdentity: number | null,
  signature: string,
  campaignId?: number
) => {
  const payload = {
    medCenterId,
    personId,
    consent,
    certifyIdentity,
    signature,
  };
  const headers = authHeaders();
  const baseUrl = apiUrl + '/v2/campaign/condition/medical_professional';
  const url = campaignId ? baseUrl + '?campaign_id=' + campaignId : baseUrl;
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const addNewMedicalProfessional = async (
  med_center_name: string,
  med_center_id: number | null,
  location: string,
  person: object,
  mp_give_consent_for_mp_to_provide_info: boolean,
  mp_certify_identity: number | null,
  mp_signature: string,
  campaignId?: number
) => {
  const headers = authHeaders();
  const baseUrl = apiUrl + '/v2/campaign/add_medical_professional';
  const url = campaignId ? baseUrl + '?campaign_id=' + campaignId : baseUrl;
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      med_center_name,
      med_center_id,
      location,
      person,
      mp_give_consent_for_mp_to_provide_info,
      mp_certify_identity,
      mp_signature,
    }),
  });
  const json = await resp.json();
  return json;
};

export const setCampaignCost = async (
  medical_expense_codes,
  anticipated_cost
) => {
  const payload = {
    medical_expense_codes,
    anticipated_cost,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/financials/cost';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setCampaignContribution = async (payload, campaignId) => {
  const headers = authHeaders();
  const baseUrl = apiUrl + '/v2/campaign/financials/contribution';
  const url = campaignId ? baseUrl + '?campaign_id=' + campaignId : baseUrl;
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setCampaignInsurance = async (payload, campaignId) => {
  const headers = authHeaders();
  const baseUrl = apiUrl + '/v2/campaign/financials/insurance';
  const url = campaignId ? baseUrl + '?campaign_id=' + campaignId : baseUrl;
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setCampaignCommunity = async (community_type_codes) => {
  const payload = {
    community_type_codes,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/community';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setTermClauses = async (payload) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/setTermClauses';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setAgreementClauses = async (payload, campaignId) => {
  const headers = authHeaders();
  const baseUrl = apiUrl + '/v2/campaign/setAgreementClauses';
  const url = campaignId ? baseUrl + '?campaign_id=' + campaignId : baseUrl;
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setAgreementTermPublicContent = async (payload, campaignId) => {
  const headers = authHeaders();
  const baseUrl = apiUrl + '/v2/campaign/setAgreementTermPublicContent';
  const url = campaignId ? baseUrl + '?campaign_id=' + campaignId : baseUrl;
  const resp = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const subscribeToBlog = async (payload: {
  email?: string;
  first_name: string;
  last_name: string;
}) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/subscribeToBlog';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setOtherTermClauses = async (payload) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/setOtherTermClauses';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setContactPreference = async (payload) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/setContactPreference';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};
